var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "error-layout" } }, [
    this.$maDomain
      ? _c("div", { staticClass: "container" }, [
          _c("p", { staticClass: "headline-large gray" }, [
            _vm._v(_vm._s(_vm.$t("errorView.title"))),
          ]),
          _c("div", { staticClass: "container-img" }, [
            _c("img", {
              attrs: { src: require("@/assets/images/self-care/error.png") },
            }),
            _c("p", { staticClass: "text-medium gray mg mg--t-5" }, [
              _vm._v(_vm._s(_vm.$t("errorView.text"))),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "container-img" }, [
            _c("p", { staticClass: "headline-large gray mg mg--b-4" }, [
              _vm._v(_vm._s(_vm.$t("errorView.allianz.text"))),
            ]),
            _c(
              "p",
              {
                staticClass: "headline-medium-regular gray mg mg--b-4 margin-a",
              },
              [_vm._v(_vm._s(_vm.$t("errorView.allianz.text1")))]
            ),
            _c(
              "p",
              { staticClass: "text-large-regular gray mg mg--b-4 margin-a" },
              [_vm._v(_vm._s(_vm.$t("errorView.allianz.text2")))]
            ),
            _c("img", {
              staticClass: "end-image",
              attrs: { src: require("@/assets/end_background_img.jpeg") },
            }),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }